<template>
	<div class="v5-tab">
		<slot>
		</slot>
	</div>
</template>
<script>
import Emitter from '../../mixins/emitter';
export default {
	name: 'v5-tab',
	mixins: [Emitter],
	props: ['value'],
	watch: {
		value(val) {
			this.currentActive = val;
		},
		currentActive(val) {
			this.broadcast('v5-tab-item', 'update', val);
		}
	},
	data() {
		return {
			currentActive: this.value
		};
	},
	created() {
		this.$on('input', function(val) {
			this.currentActive = val;
		});
	},
	mounted() {
		if (this.value) {
			this.broadcast('v5-tab-item', 'update', this.value);
		}
	}
};
</script>
<style lang="scss">
@import './style.scss';
</style>
